var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumburgerW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8.75C7.63069 8.75 8.75 7.63069 8.75 6.25C8.75 4.86929 7.63069 3.75 6.25 3.75C4.86929 3.75 3.75 4.86929 3.75 6.25C3.75 7.63069 4.86929 8.75 6.25 8.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.75C16.3807 8.75 17.5 7.63069 17.5 6.25C17.5 4.86929 16.3807 3.75 15 3.75C13.6193 3.75 12.5 4.86929 12.5 6.25C12.5 7.63069 13.6193 8.75 15 8.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 8.75C25.1307 8.75 26.25 7.63069 26.25 6.25C26.25 4.86929 25.1307 3.75 23.75 3.75C22.3693 3.75 21.25 4.86929 21.25 6.25C21.25 7.63069 22.3693 8.75 23.75 8.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 17.5C7.63069 17.5 8.75 16.3807 8.75 15C8.75 13.6193 7.63069 12.5 6.25 12.5C4.86929 12.5 3.75 13.6193 3.75 15C3.75 16.3807 4.86929 17.5 6.25 17.5Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.5C16.3807 17.5 17.5 16.3807 17.5 15C17.5 13.6193 16.3807 12.5 15 12.5C13.6193 12.5 12.5 13.6193 12.5 15C12.5 16.3807 13.6193 17.5 15 17.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 17.5C25.1307 17.5 26.25 16.3807 26.25 15C26.25 13.6193 25.1307 12.5 23.75 12.5C22.3693 12.5 21.25 13.6193 21.25 15C21.25 16.3807 22.3693 17.5 23.75 17.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 26.25C7.63069 26.25 8.75 25.1307 8.75 23.75C8.75 22.3693 7.63069 21.25 6.25 21.25C4.86929 21.25 3.75 22.3693 3.75 23.75C3.75 25.1307 4.86929 26.25 6.25 26.25Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26.25C16.3807 26.25 17.5 25.1307 17.5 23.75C17.5 22.3693 16.3807 21.25 15 21.25C13.6193 21.25 12.5 22.3693 12.5 23.75C12.5 25.1307 13.6193 26.25 15 26.25Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 26.25C25.1307 26.25 26.25 25.1307 26.25 23.75C26.25 22.3693 25.1307 21.25 23.75 21.25C22.3693 21.25 21.25 22.3693 21.25 23.75C21.25 25.1307 22.3693 26.25 23.75 26.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumburgerW);
export default __webpack_public_path__ + "static/media/humburgerW.eba9f5003b85310330c2d48c11214946.svg";
export { ForwardRef as ReactComponent };